import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MetaData } from "../../utils/imports";
import { useDispatch, useSelector } from "react-redux";
import { EMPTY_PURCHASE } from "../../constants/purchaseConstants";
import successfull from "../../assets/images/Transaction/success.png";
import failed from "../../assets/images/Transaction/failed.png";
import { emptyCart } from "../../actions/cartAction";
import PropTypes from "prop-types";

const OrderSuccess = ({ success }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [time, setTime] = useState(3);

  const { directPurchase } = useSelector((state) => state.purchase);

  useEffect(() => {
    if (time === 0) {
      if (success) {
        if (!directPurchase) {
          dispatch(emptyCart());
        }
        dispatch({ type: EMPTY_PURCHASE });
        navigate("/orders");
      } else {
        navigate("/cart");
      }
      return;
    }
    const intervalId = setInterval(() => {
      setTime(time - 1);
    }, 1000);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line
  }, [time]);

  return (
    <>
      <MetaData title={`Transaction ${success ? "Successfull" : "Failed"}`} />
      <main className="w-full mt-16 md:mt-24">
        <div className="flex flex-col gap-2 items-center justify-center sm:w-4/6 sm:mt-4 m-auto mb-7 bg-white shadow rounded p-6 pb-12">
          <img
            draggable="false"
            className="w-1/2 h-60 object-contain"
            src={success ? successfull : failed}
            alt="Transaction Status"
          />
          <div className="text-2xl font-semibold">
            Transaction {success ? "Successfull" : "Failed"}
          </div>
          <p className="mt-4 text-lg text-gray-800">
            Redirecting to {success ? "orders" : "cart"} in {time} sec
          </p>
          <Link
            to={success ? "/orders" : "/cart"}
            className="bg-primary-blue mt-2 py-2.5 px-6 text-white uppercase shadow hover:shadow-lg rounded-sm"
          >
            go to {success ? "orders" : "cart"}
          </Link>
        </div>
      </main>
    </>
  );
};

OrderSuccess.propTypes = {
  success: PropTypes.bool.isRequired,
};

export default OrderSuccess;
